import styled from "@emotion/styled"

const WrAPPER = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
@media screen and (max-width:666px){
  display: inline-block;
}
`
const SocialHeading = styled.span`
color: #fff;
font-size: 20px;
`
const SocialMedia = styled.div`
display: flex;
padding: 10px 0;
align-items: center;
`
const SocialLinks = styled.a`
text-decoration:UNDERLINE;
color:#fff;
`
const SocialImage = styled.img`
width:100% ;
height: auto;
max-width: 50px;
padding-right:15px;
`
const ParaDesktop = styled.div`
@media screen and (max-width:670px){
  display: none;
}
`
const MobPara = styled.div`
display: none;
@media screen and (max-width:670px){
  display: flex;
}
`
export { WrAPPER, SocialHeading, SocialMedia, SocialLinks, SocialImage, ParaDesktop, MobPara, }